import { BREEDING_ID } from "../constants";

export const getBreedingId = () => {
  const breedingId = localStorage.getItem(BREEDING_ID);
  return breedingId || null;
};
